import jwtDecode from "jwt-decode";
import {
  getLocalStorage,
  setLocalStorage,
  clearLocalStorage,
} from "./storage.utils";
import { JWT_TOKEN } from "../../constants/appConfig";

export let isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp < Date.now() / 1000) {
      // Checking if token is expired.
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const getUserDetailsFromToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    if (decoded) {
      setLocalStorage("COS_MILANO_WEB_USER", decoded);
      return decoded;
    }
  } catch (e) {
    return false;
  }
};

export let getToken = () => {
  return getLocalStorage(JWT_TOKEN);
};

export let isAuthenticated = () => {
  return !!getToken() && !isTokenExpired(getToken());
  // return true;
};

export let getUserData = () => {
  return getLocalStorage("COS_MILANO_USER_INFO");
};

export let isUserLoggedIn = () => {
  return !!getUserData();
};

export const logout = () => {
  clearLocalStorage("cos-milano-web-token");
  clearLocalStorage("COS_MILANO_WEB_USER");
  clearLocalStorage("cos-milano-web-cart");
  history.push("/");
};
